import { useState } from "react";
import { Outlet } from "react-router-dom";
import DashboardHeader from "./DashboardHeader";
import Sidebar from "./Sidebar";

const DashboardLayout = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);

  return (
    <div className="min-h-screen bg-white">
      <DashboardHeader
        onMenuClick={() => setSidebarOpen((o) => !o)}
      />

      <div className="flex">
        {/* Backdrop on mobile when sidebar open */}
        <button
          type="button"
          aria-label="Mbyll menunë"
          onClick={() => setSidebarOpen(false)}
          className={`fixed inset-0 z-40 bg-black/50 md:hidden transition-opacity ${
            sidebarOpen ? "opacity-100" : "opacity-0 pointer-events-none"
          }`}
        />

        <Sidebar
          isOpen={sidebarOpen}
          onClose={() => setSidebarOpen(false)}
        />

        <main className="flex-1 w-full min-w-0 p-4 sm:p-6">
          <Outlet />
        </main>
      </div>
    </div>
  );
};

export default DashboardLayout;
